import React, { useState } from "react";
import "../styles/MobileLogin.css";
import Advert from "./Advert";
import { useNavigate, useLocation } from "react-router-dom";
import api from "../context/api";
import { toast, ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";

export default function SendexaResetVerify() {
  const navigate = useNavigate();
  const location = useLocation();
  const { phoneNumber, otpId } = location.state || {};

  const [otpCode, setOtpCode] = useState("");
  const [newPassword, setNewPassword] = useState("");
  const [confirmPassword, setConfirmPassword] = useState("");
  const [isLoading, setIsLoading] = useState(false);

  React.useEffect(() => {
    if (!phoneNumber) {
      toast.error("Invalid reset session. Please start over.");
      navigate("/password-reset-sendexa");
    }
  }, [phoneNumber, navigate]);

  const handleVerifyAndReset = async () => {
    if (!otpCode || otpCode.trim().length < 4) {
      toast.error("Please enter the OTP code.");
      return;
    }

    if (!newPassword || newPassword.length < 6) {
      toast.error("Password must be at least 6 characters.");
      return;
    }

    if (newPassword !== confirmPassword) {
      toast.error("Passwords do not match.");
      return;
    }

    setIsLoading(true);
    try {
      const response = await api.post("/sendexa/password-reset/verify", {
        phoneNumber,
        otpId,
        otpCode: otpCode.trim(),
        newPassword,
      });

      if (response.data?.success) {
        toast.success("Password reset successful.");
        setTimeout(() => navigate("/login"), 1200);
      } else {
        toast.error(response.data?.message || "OTP verification failed.");
      }
    } catch (error) {
      const message =
        error.response?.data?.message ||
        "Could not verify OTP. Please try again.";
      toast.error(message);
    } finally {
      setIsLoading(false);
    }
  };

  return (
    <div className="login-container">
      <ToastContainer position="top-right" autoClose={3000} hideProgressBar={false} />
      <div className="login-image-top"></div>
      <div className="login-box">
        <h1>Verify OTP</h1>
        <p>Enter the OTP sent to your phone and set a new password</p>

        <form
          onSubmit={(e) => {
            e.preventDefault();
            handleVerifyAndReset();
          }}
        >
          <div className="input-group">
            <input
              type="text"
              placeholder="Enter OTP"
              value={otpCode}
              onChange={(e) => setOtpCode(e.target.value)}
              required
            />
          </div>

          <div className="input-group">
            <input
              type="password"
              placeholder="New Password"
              value={newPassword}
              onChange={(e) => setNewPassword(e.target.value)}
              required
            />
          </div>

          <div className="input-group">
            <input
              type="password"
              placeholder="Confirm New Password"
              value={confirmPassword}
              onChange={(e) => setConfirmPassword(e.target.value)}
              required
            />
          </div>

          <button type="submit" disabled={isLoading}>
            {isLoading ? "Processing..." : "Verify & Reset Password"}
          </button>
        </form>

        <div className="links">
          <span>
            Start over? <a href="#" onClick={() => navigate("/password-reset-sendexa")}>Resend OTP</a>
          </span>
          <span>
            Remember your password? <a href="#" onClick={() => navigate("/login")}>Login</a>
          </span>
        </div>
      </div>
      <div style={{ marginTop: "90px", width: "100%" }}>
        <Advert />
      </div>
    </div>
  );
}
